module.exports = __webpack_public_path__ + "media/assets/landing_page_share_projects-06790b1e.svg";